/** Point réseau de l'en-tête : vert en ligne, rouge hors ligne. */
import { useEffect, useState } from 'react';
import { cn } from '@/lib/utils';

export function NetworkDot() {
  const [online, setOnline] = useState(() => navigator.onLine);
  useEffect(() => {
    const update = () => setOnline(navigator.onLine);
    window.addEventListener('online', update);
    window.addEventListener('offline', update);
    return () => {
      window.removeEventListener('online', update);
      window.removeEventListener('offline', update);
    };
  }, []);
  return (
    <span
      role="img"
      aria-label={online ? 'En ligne' : 'Hors ligne'}
      title={online ? 'En ligne' : 'Hors ligne'}
      className="flex h-12 w-8 shrink-0 items-center justify-center"
    >
      <span
        className={cn('h-3 w-3 rounded-full', online ? 'bg-green-500' : 'animate-pulse bg-red-500')}
      />
    </span>
  );
}
